import { PlusOutlined } from "@ant-design/icons";
import { Button, Card, notification, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import { getUserRole } from "../../services/util";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";
import AddEditAlarm from "./AddEditAlarm";
import AlarmHistoryModal from "./AlarmHistoryModal";
import "./Alarms.css";
import column from "./column";

const alarmsEmpty = {
    staff_id: 1,
    alarm_name: "",
    priority: 1,
    alarm_type: [1],
    alarm_hotel_ids: [],
    alarm_send_to_email: true,
    alarm_send_to_phone: true,
    alarm_email_ids: [],
    alarm_phone_numbers: [],
};

const alarmPriority = [
    { name: "High", value: 1 },
    { name: "Medium", value: 2 },
    { name: "Low", value: 3 },
];

const alarmType = [
    { key: 1, title: "Support Ticket Create" },
    { key: 2, title: "Support Ticket Update" },
    { key: 3, title: "Support Ticket Close" },
    { key: 4, title: "Bad Reviews feedback" },
];

const Alarms = () => {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [formData, setFormData] = useState({
        staff_id,
        page: 0,
        limit: 10,
    });
    const [totalAlarms, setTotalAlarms] = useState(0);
    const [isVisible, setIsVisible] = useState(false);
    const [alarmItem, setAlarmItem] = useState(alarmsEmpty);
    const [alarmsData, setAlarmsData] = useState([]);

    const [isShowHistory, setIsShowHistory] = useState(false);
    const [historyData, setHistoryData] = useState([]);
    const [totalAlarmsHistory, setTotalAlarmsHistory] = useState(0);
    const userRoleId = localStorage.getItem("userRoleId");
    const userRole = getUserRole(userRoleId);

    const { data: hotelListRes, refetch: getHotelList } = useQuery(
        "mapHotels",
        async () => {
            return await HTTP("/dashboard/getMapHotels", { staff_id });
        },
        { enabled: false },
    );
    const {
        status: alarmsStatus,
        data: alarms,
        refetch: getAlarms,
    } = useQuery(
        "alarms",
        async () => {
            return await HTTP("/alarms/getAlarms", { ...formData });
        },
        { enabled: false },
    );

    useEffect(() => {
        getAlarms();
        getHotelList();
    }, [formData]);

    useEffect(() => {
        if (alarmsStatus === "success") {
            setTotalAlarms(alarms.total);
            setAlarmsData(alarms.data);
        }
    }, [alarmsStatus, alarms]);

    const openAlarmModal = (record) => {
        if (userRole !== "Super Admin" && userRole !== "Admin") {
            return notification["error"]({
                message: "You are not allowed to perform this action.",
            });
        }
        setAlarmItem(record);
        setIsVisible(true);
    };

    const closeModal = () => {
        setIsVisible(false);
        setAlarmItem(alarmsEmpty);
        getAlarms();
    };

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        } else {
            delete formData.sorting;
            delete formData.sort_by;
        }
        const updatedFormData = { ...formData, ...others };
        setFormData(updatedFormData);
    }

    const showHistory = async (e) => {
        const newFormData = {
            staff_id: 1,
            limit: 10,
            page: 0,
            sort_by: "",
            sorting: 1,
            alarm_id: e.currentTarget.getAttribute("id"),
        };
        const { success, data, message, total } = await HTTP(
            "/alarms/getAlarmsHistory",
            newFormData,
        );

        if (success) {
            setHistoryData(data);
            setTotalAlarmsHistory(total);
            setIsShowHistory(true);
        } else {
            notification["error"]({
                message,
            });
        }
    };

    const closeHistoryModal = () => {
        setIsShowHistory(false);
        setHistoryData([]);
        setTotalAlarmsHistory(0);
    };

    return (
        <Card className="dashboard-container">
            <CustomHeader
                extraAfter={
                    (userRole === "Super Admin" ||
                        userRole === "Admin" ||
                        userRole === "Support") && (
                        <Button
                            type="primary"
                            style={{ marginRight: "5px" }}
                            onClick={() => setIsVisible(true)}
                        >
                            <PlusOutlined /> Add
                        </Button>
                    )
                }
            />
            {alarmsStatus !== "loading" && alarmsStatus !== "idle" ? (
                <CustomTable
                    columns={column({
                        openAlarmModal,
                        getAlarms,
                        hotelListRes,
                        alarmPriority,
                        alarmType,
                        showHistory,
                    })}
                    handleTableChange={handleTableChange}
                    tableData={alarmsData}
                    noOfrecords={totalAlarms}
                    rowKey="id"
                    isScroll
                />
            ) : (
                <Skeleton
                    active
                    title={false}
                    paragraph={{ rows: 20, width: 40 }}
                />
            )}
            {isVisible && (
                <AddEditAlarm
                    visible={isVisible}
                    onClose={closeModal}
                    record={alarmItem}
                    hotels={hotelListRes}
                    alarmType={alarmType}
                    alarmPriority={alarmPriority}
                />
            )}
            {isShowHistory && (
                <AlarmHistoryModal
                    visible={isShowHistory}
                    onClose={closeHistoryModal}
                    data={{ historyData, totalAlarmsHistory, hotelListRes }}
                />
            )}
        </Card>
    );
};

export { Alarms };
